import { render, staticRenderFns } from "./baseSidebar.vue?vue&type=template&id=2d315934"
import script from "./baseSidebar.vue?vue&type=script&lang=js"
export * from "./baseSidebar.vue?vue&type=script&lang=js"
import style0 from "./baseSidebar.vue?vue&type=style&index=0&id=2d315934&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports